import { tenantFromLocation } from './tenant.ts';

/**
 * @fileoverview The site's own pages — those that name no organization
 * (2026-09-25, OQ-48).
 *
 *     /         the landing page: `mapshare.fyi/`, and the root of every
 *               environment (`localhost:8787/`, a preview, `staging.mapshare.fyi/`)
 *     /status   whether MapShare is up (`site/StatusPage.tsx`); the health
 *               scaffold that `/` used to be, a public status page since
 *               2026-09-26
 *
 * **In path mode the first segment is read as an organization**, so a site
 * page's name must be a reserved slug, or an organization could take it
 * (invariant 6). `site-pages.test.ts` holds that, as `screens.test.ts` does
 * for an organization's screens.
 */
export const SITE_PAGES = { landing: '/', status: '/status' } as const;

/**
 * Whether this URL is the landing page. Only the landing page is decided here;
 * everything else — `/status` included — is `app-routes.tsx`'s, loaded as a
 * separate chunk so the landing page stays light.
 */
export function isLandingPage(location: { hostname: string; pathname: string }): boolean {
  return location.pathname === SITE_PAGES.landing && tenantFromLocation(location) === null;
}
